import { Input, theme } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { controlHeightTokens, radiusTokens } from '@/styles/tokens';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: number | string;
  className?: string;
}

/**
 * Standardized search input with purple icon
 * @param value - Current search value
 * @param onChange - Change handler
 * @param placeholder - Placeholder text
 * @param width - Input width (default: 450px)
 * @param className - Additional CSS classes
 */
const SearchInput = ({
  value,
  onChange,
  placeholder = 'Search...',
  width = 450,
  className = '',
}: SearchInputProps) => {
  const { token } = theme.useToken();

  return (
    <Input
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      variant="outlined"
      size="large"
      className={className}
      suffix={
        <SearchOutlined
          style={{
            fontSize: token.sizeMD,
            color: token.colorPrimary,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
          }}
        />
      }
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        borderRadius: radiusTokens.card,
        height: `${controlHeightTokens.controlHeightXL}px`,
        transition: 'all 0.3s ease',
      }}
      styles={{
        input: {
          borderRadius: radiusTokens.card,
        },
      }}
    />
  );
};

export default SearchInput;
